import { useState, useRef, useEffect } from "react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
  Sidebar,
  ExpansionPanel,
  Avatar,
} from "@chatscope/chat-ui-kit-react";
import { ReactComponent as ClearIcon } from "../../../assets/clear.svg";
import Prism from "prismjs";
import "prismjs/components/prism-python";
import "prismjs/themes/prism-funky.css";
import { sliceText } from "../../../api/sliceCode";
import { generateResponse } from "../../../api/api";

// The Open Ai chat Bot

function DaVinciBotTuner(props) {
  const inputRef = useRef();
  // useEffect(() => inputRef.current.focus());
  useEffect(() => {
    import("./DaVinciBotTuner.css")
  }, [])
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [userMsg, setUserMsg] = useState('');
  const [temp, setTemp] = useState(0.7);
  const [maxTokens, setMaxTokens] = useState(140);
  const [topP, setTopP] = useState(0.1)

  const handlePaste = (event) => {
    event.preventDefault();

    // Access the pasted text
    const text = event.clipboardData.getData('text/plain');

    // Set the input value to the plain text
    setUserMsg(text);
  };


  let systemMessage = {
    role: "system",
    content: `You are an AI assistant used in the Prompt Training Course that allows users to try different prompt engineering techniques. The user will provide a prompt, you have to answer questions based on the user's query`,
  };

  const handleSend = async (message) => {
    const newMessage = {
      message,
      direction: "outgoing",
      sender: "user",
    };
    setUserMsg('')

    const newMessages = [...messages, newMessage];
    setMessages(newMessages);
    sessionStorage.setItem("message", JSON.stringify(newMessages));
    setIsTyping(true);
    await processMessageToDojoBot(newMessages);
  };

  async function processMessageToDojoBot(chatMessages) {
    // messages is an array of messages
    // Format messages for DojoBot API
    // API is expecting objects in format of { role: "user" or "assistant", "content": "message here"}
    // So we need to reformat

    let apiMessages = chatMessages.map((messageObject) => {
      let role = "";
      if (messageObject?.sender === "DojoBot") {
        role = "assistant";
      } else {
        role = "user";
      }
      return { role: role, content: messageObject.message };
    });

    // Get the request body set up with the model we plan to use
    // and the messages which we formatted above. We add a system message in the front to'
    // determine how we want DojoBot to act.
    const apiRequestBody = {
      model: "davinci-003",
      temperature: temp,
      top_p: topP,
      max_tokens: maxTokens,
      messages: [
        systemMessage, // The system message DEFINES the logic of our DojoBot
        ...apiMessages, // The messages from our chat with DojoBot
      ],
    };

    await generateResponse(apiRequestBody)
      .then((data) => {
        const codeSegments = sliceText(data.choices[0].message.content);
        let newMessage;
        if (codeSegments) {
          let message = "";
          for (const segment of codeSegments) {
            const { beforeCode, code, afterCode } = segment;
            const styledCode = `
                <div class ="codeEmbbed">
                  <button class = "codeEmbbedBtn"
                  onclick="(function(parentElement) {
                    const codeElement = parentElement.querySelector('pre code');
                    const code = codeElement.innerText;
                    const codeElementTemp = document.createElement('textarea');
                    codeElementTemp.value = code;
                    document.body.appendChild(codeElementTemp);
                    codeElementTemp.select();
                    document.execCommand('copy');
                    document.body.removeChild(codeElementTemp);
                  })(this.parentNode)"
                  ><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" zoomAndPan="magnify" viewBox="0 0 375 374.999991" height="500" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><clipPath id="cc872461f2"><path d="M 112.5 112.5 L 262.5 112.5 L 262.5 262.5 L 112.5 262.5 Z M 112.5 112.5 " clip-rule="nonzero"/></clipPath></defs><g clip-path="url(#cc872461f2)"><path fill="#ffffff" d="M 247.5 112.5 L 157.5 112.5 C 156.515625 112.5 155.539062 112.597656 154.574219 112.789062 C 153.609375 112.980469 152.667969 113.265625 151.757812 113.640625 C 150.851562 114.019531 149.984375 114.480469 149.167969 115.027344 C 148.347656 115.574219 147.589844 116.195312 146.894531 116.894531 C 146.195312 117.589844 145.574219 118.347656 145.027344 119.167969 C 144.480469 119.984375 144.019531 120.851562 143.640625 121.757812 C 143.265625 122.667969 142.980469 123.609375 142.789062 124.574219 C 142.597656 125.539062 142.5 126.515625 142.5 127.5 L 142.5 142.5 L 127.5 142.5 C 126.515625 142.5 125.539062 142.597656 124.574219 142.789062 C 123.609375 142.980469 122.667969 143.265625 121.757812 143.640625 C 120.851562 144.019531 119.984375 144.480469 119.167969 145.027344 C 118.347656 145.574219 117.589844 146.195312 116.894531 146.894531 C 116.195312 147.589844 115.574219 148.347656 115.027344 149.167969 C 114.480469 149.984375 114.019531 150.851562 113.640625 151.757812 C 113.265625 152.667969 112.980469 153.609375 112.789062 154.574219 C 112.597656 155.539062 112.5 156.515625 112.5 157.5 L 112.5 247.5 C 112.5 248.484375 112.597656 249.460938 112.789062 250.425781 C 112.980469 251.390625 113.265625 252.332031 113.640625 253.238281 C 114.019531 254.148438 114.480469 255.015625 115.027344 255.832031 C 115.574219 256.652344 116.195312 257.410156 116.894531 258.105469 C 117.589844 258.804688 118.347656 259.425781 119.167969 259.972656 C 119.984375 260.519531 120.851562 260.980469 121.757812 261.359375 C 122.667969 261.734375 123.609375 262.019531 124.574219 262.210938 C 125.539062 262.402344 126.515625 262.5 127.5 262.5 L 217.5 262.5 C 218.484375 262.5 219.460938 262.402344 220.425781 262.210938 C 221.390625 262.019531 222.332031 261.734375 223.242188 261.359375 C 224.148438 260.980469 225.015625 260.519531 225.832031 259.972656 C 226.652344 259.425781 227.410156 258.804688 228.105469 258.105469 C 228.804688 257.410156 229.425781 256.652344 229.972656 255.832031 C 230.519531 255.015625 230.980469 254.148438 231.359375 253.238281 C 231.734375 252.332031 232.019531 251.390625 232.210938 250.425781 C 232.402344 249.460938 232.5 248.484375 232.5 247.5 L 232.5 232.5 L 247.5 232.5 C 248.484375 232.5 249.460938 232.402344 250.425781 232.210938 C 251.390625 232.019531 252.332031 231.734375 253.242188 231.359375 C 254.148438 230.980469 255.015625 230.519531 255.832031 229.972656 C 256.652344 229.425781 257.410156 228.804688 258.105469 228.105469 C 258.804688 227.410156 259.425781 226.652344 259.972656 225.832031 C 260.519531 225.015625 260.980469 224.148438 261.359375 223.242188 C 261.734375 222.332031 262.019531 221.390625 262.210938 220.425781 C 262.402344 219.460938 262.5 218.484375 262.5 217.5 L 262.5 127.5 C 262.5 126.515625 262.402344 125.539062 262.210938 124.574219 C 262.019531 123.609375 261.734375 122.667969 261.359375 121.757812 C 260.980469 120.851562 260.519531 119.984375 259.972656 119.167969 C 259.425781 118.347656 258.804688 117.589844 258.105469 116.894531 C 257.410156 116.195312 256.652344 115.574219 255.832031 115.027344 C 255.015625 114.480469 254.148438 114.019531 253.238281 113.640625 C 252.332031 113.265625 251.390625 112.980469 250.425781 112.789062 C 249.460938 112.597656 248.484375 112.5 247.5 112.5 Z M 222.5 247.5 C 222.5 247.828125 222.46875 248.152344 222.402344 248.476562 C 222.339844 248.796875 222.246094 249.109375 222.121094 249.414062 C 221.992188 249.714844 221.839844 250.003906 221.65625 250.277344 C 221.476562 250.550781 221.269531 250.804688 221.035156 251.035156 C 220.804688 251.269531 220.550781 251.476562 220.277344 251.65625 C 220.003906 251.839844 219.714844 251.992188 219.414062 252.121094 C 219.109375 252.246094 218.796875 252.339844 218.476562 252.402344 C 218.152344 252.46875 217.828125 252.5 217.5 252.5 L 127.5 252.5 C 127.171875 252.5 126.847656 252.46875 126.523438 252.402344 C 126.203125 252.339844 125.890625 252.246094 125.585938 252.121094 C 125.285156 251.992188 124.996094 251.839844 124.722656 251.65625 C 124.449219 251.476562 124.195312 251.269531 123.964844 251.035156 C 123.730469 250.804688 123.523438 250.550781 123.34375 250.277344 C 123.160156 250.003906 123.007812 249.714844 122.878906 249.414062 C 122.753906 249.109375 122.660156 248.796875 122.597656 248.476562 C 122.53125 248.152344 122.5 247.828125 122.5 247.5 L 122.5 157.5 C 122.5 157.171875 122.53125 156.847656 122.597656 156.523438 C 122.660156 156.203125 122.753906 155.890625 122.878906 155.585938 C 123.007812 155.285156 123.160156 154.996094 123.34375 154.722656 C 123.523438 154.449219 123.730469 154.195312 123.964844 153.964844 C 124.195312 153.730469 124.449219 153.523438 124.722656 153.34375 C 124.996094 153.160156 125.285156 153.007812 125.585938 152.878906 C 125.890625 152.753906 126.203125 152.660156 126.523438 152.597656 C 126.847656 152.53125 127.171875 152.5 127.5 152.5 L 217.5 152.5 C 217.828125 152.5 218.152344 152.53125 218.476562 152.597656 C 218.796875 152.660156 219.109375 152.753906 219.414062 152.878906 C 219.714844 153.007812 220.003906 153.160156 220.277344 153.34375 C 220.550781 153.523438 220.804688 153.730469 221.035156 153.964844 C 221.269531 154.195312 221.476562 154.449219 221.65625 154.722656 C 221.839844 154.996094 221.992188 155.285156 222.121094 155.585938 C 222.246094 155.890625 222.339844 156.203125 222.402344 156.523438 C 222.46875 156.847656 222.5 157.171875 222.5 157.5 Z M 252.5 217.5 C 252.5 217.828125 252.46875 218.152344 252.402344 218.476562 C 252.339844 218.796875 252.246094 219.109375 252.121094 219.414062 C 251.992188 219.714844 251.839844 220.003906 251.65625 220.277344 C 251.476562 220.550781 251.269531 220.804688 251.035156 221.035156 C 250.804688 221.269531 250.550781 221.476562 250.277344 221.65625 C 250.003906 221.839844 249.714844 221.992188 249.414062 222.121094 C 249.109375 222.246094 248.796875 222.339844 248.476562 222.402344 C 248.152344 222.46875 247.828125 222.5 247.5 222.5 L 232.5 222.5 L 232.5 157.5 C 232.5 156.515625 232.402344 155.539062 232.210938 154.574219 C 232.019531 153.609375 231.734375 152.667969 231.359375 151.757812 C 230.980469 150.851562 230.519531 149.984375 229.972656 149.167969 C 229.425781 148.347656 228.804688 147.589844 228.105469 146.894531 C 227.410156 146.195312 226.652344 145.574219 225.832031 145.027344 C 225.015625 144.480469 224.148438 144.019531 223.242188 143.640625 C 222.332031 143.265625 221.390625 142.980469 220.425781 142.789062 C 219.460938 142.597656 218.484375 142.5 217.5 142.5 L 152.5 142.5 L 152.5 127.5 C 152.5 127.171875 152.53125 126.847656 152.597656 126.523438 C 152.660156 126.203125 152.753906 125.890625 152.878906 125.585938 C 153.007812 125.285156 153.160156 124.996094 153.34375 124.722656 C 153.523438 124.449219 153.730469 124.195312 153.964844 123.964844 C 154.195312 123.730469 154.449219 123.523438 154.722656 123.34375 C 154.996094 123.160156 155.285156 123.007812 155.585938 122.878906 C 155.890625 122.753906 156.203125 122.660156 156.523438 122.597656 C 156.847656 122.53125 157.171875 122.5 157.5 122.5 L 247.5 122.5 C 247.828125 122.5 248.152344 122.53125 248.476562 122.597656 C 248.796875 122.660156 249.109375 122.753906 249.414062 122.878906 C 249.714844 123.007812 250.003906 123.160156 250.277344 123.34375 C 250.550781 123.523438 250.804688 123.730469 251.035156 123.964844 C 251.269531 124.195312 251.476562 124.449219 251.65625 124.722656 C 251.839844 124.996094 251.992188 125.285156 252.121094 125.585938 C 252.246094 125.890625 252.339844 126.203125 252.402344 126.523438 C 252.46875 126.847656 252.5 127.171875 252.5 127.5 Z M 252.5 217.5 " fill-opacity="1" fill-rule="nonzero"/></g></svg>Copy</button>
                  <pre><code class="language-python">${code}</code></pre>
                </div>
                `;
            message += `${beforeCode} ${styledCode}${afterCode}`;
          }
          newMessage = {
            message,
            sender: "DojoBot",
            type: "html",
            direction: "incoming",
          };
        } else {
          newMessage = {
            message: data.choices[0].message.content,
            sender: "DojoBot",
            type: "html",
            direction: "incoming",
          };
        }
        setMessages([...chatMessages, newMessage]);
        sessionStorage.setItem(
          "message",
          JSON.stringify([...chatMessages, newMessage])
        );
        setIsTyping(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  useEffect(() => {
    Prism.highlightAll();
  });

  return (

    <div style={{ height: "100%", width: "100%" }}>
      <Sidebar style={{ height: 'auto' }}>
        <ExpansionPanel title="Parameters">
          <div className="settings-container">
            <div className="slidecontainer">
              <input type="range" min="0" max="2" step="0.1" value={temp} onChange={(e) => { setTemp(parseFloat(e?.target?.value)) }} className="slider" id="myRange" />
              <p className="text-contain">Temperature: {temp}</p>
            </div>
            <div className="slidecontainer">
              <input type="range" min="15" max="1024" step="1" value={maxTokens} onChange={(e) => { setMaxTokens(parseInt(e?.target?.value)) }} className="slider" id="myRange" />
              <p className="text-contain">Max Tokens: {maxTokens}</p>
            </div>
            <div className="slidecontainer">
              <input type="range" min="0" max="1" step="0.1" value={topP} onChange={(e) => { setTopP(parseFloat(e?.target?.value)) }} className="slider" id="myRange" />
              <p className="text-contain">Top P: {topP}</p>
            </div>
            {/* <div className="tokencontainer">
              <label style={{fontWeight: 500}}for="tokens">{"Top P: "}</label>
              <input value={topP} onChange={(e) => { setTopP(e?.target?.value) }} type="number" max="200" min="10" id="tokens" name="tokens" />
            </div> */}
          </div>

        </ExpansionPanel>
      </Sidebar>
      <MainContainer>
        <ChatContainer>
          <MessageList
            style={{ backgroundColor: props.theme }}
            scrollBehavior="smooth"
            typingIndicator={
              isTyping ? (
                <TypingIndicator content={"AI Tutor is typing ..."} />
              ) : null}>

            {Array.isArray(messages) &&
              messages.map((message, i) => {
                return (
                  <Message key={i} model={message}>
                    {/* <Message.Footer sender={message.sender} />{" "} */}
                    {message?.sender && message.sender === "DojoBot" ? (
                      <Avatar
                        src="https://datasciencedojo.com/wp-content/uploads/Logo_Tori_small-2.png"
                        name="DojoBot"
                        size="sm"
                      />
                    ) : (
                      ""
                    )}
                  </Message>
                );
              })}
          </MessageList>
          <div className="messageInput" as={MessageInput}>
            <div style={{ background: " rgba(243, 242, 242, 0.822)" }}>
              <ClearIcon
                className="clearIcon"
                height="36px"
                width="37px"
                onClick={() => {
                  setMessages([]);
                  setUserMsg('');
                  sessionStorage.removeItem("message");
                }}
              />
            </div>

            <MessageInput
              id="msg-input"
              style={{ flexGrow: "1", position: "relative", right: "5px", maxWidth: "90%" }}
              ref={inputRef}
              attachButton={false}
              value={userMsg}
              onChange={setUserMsg}
              placeholder="Ask me anything ... "
              onSend={handleSend}
              onPaste={handlePaste}
              sendDisabled={ userMsg?.length > 0 ? false : true }
            />

          </div>
        </ChatContainer>
      </MainContainer>
    </div>
  );
}

export default DaVinciBotTuner;
